import VerificationCodeCard from './VerificationCodeCard';

function PasswordResetCard({ user, dark, onDone, force = false }) {
    if (!force && !user?.user_metadata?.force_password_reset && !user?.app_metadata?.verification_required) return null;
    return <VerificationCodeCard user={user} purpose={force ? 'recovery' : 'invite'} onDone={onDone} />;
}

export default PasswordResetCard;
